const renderBookDeliveryTime = (data) => {
	const deliveryElement = document.querySelector('.book-delivery-time-js');
	if (data.cbh_availability.message !== undefined) {
		deliveryElement.innerHTML = 'onbekend';
	} else {
		deliveryElement.innerHTML = '1 - 3 dagen';
	}
};

if (document.querySelector('.book-delivery-time-js')) {
	const deliveryElement = document.querySelector('.book-delivery-time-js');
	const productId = deliveryElement.dataset.productId;
	// TODO: Temporarily during Corona we display a fixed variable of 10 days
	deliveryElement.innerHTML = '1 - 10 werkdagen';
	// reservationsApi.fetchBookDeliveryTime(productId, renderBookDeliveryTime);
}
